// extracted by mini-css-extract-plugin
export default {"whatsappScreen":"_6f07+","cardWrapper":"cutJj","openWhatsappButton":"p5GC4","externalIcon":"YV2nM"};